$(document).ready(function(){
    if (Core && Core.debug) console.log('Scripts after document ready is run!');
    AppVue.init();
    require('./global');
    //require('./love-you/app');
});